import { Vegsystemreferanse } from '@/domain/omrader';
import * as React from 'react';

const generateVegrefExplanation = (vegsystemreferanse: Vegsystemreferanse): string[] => {
    const parts: string[] = [];

    if (vegsystemreferanse.vegsystem) {
        const { vegkategori, fase, nummer } = vegsystemreferanse.vegsystem;

        if (vegkategori) {
            const kategoriExplanation = getVegkategoriExplanation(vegkategori);
            parts.push(`<strong>${vegkategori}</strong>: ${kategoriExplanation}`);
        }

        if (fase) {
            const faseExplanation = getFaseExplanation(fase);
            parts.push(`<strong>${fase}</strong>: ${faseExplanation}`);
        } else {
            parts.push(
                `<strong class="error-text">Ingen fase presisert</strong>: Søk inkluderer eksisterende (V), under bygging (A) og planlagte (P)`
            );
        }

        if (nummer) {
            parts.push(`<strong>${nummer}</strong>: Vegnummer`);
        }
    }

    if (vegsystemreferanse.strekning) {
        const { strekningsNummer, delstrekningsNummer, trafikantgruppe } =
            vegsystemreferanse.strekning;

        if (trafikantgruppe) {
            const trafikantgruppeExplanation =
                getTrafikantgruppeExplanation(trafikantgruppe);
            parts.push(
                `<strong>${trafikantgruppe}</strong>: ${trafikantgruppeExplanation}`
            );
        }

        if (strekningsNummer) {
            parts.push(
                `<strong>S${strekningsNummer.startEllerPunkt}</strong>: Strekningsnummer`
            );
        }

        if (delstrekningsNummer) {
            parts.push(
                `<strong>D${delstrekningsNummer.startEllerPunkt}</strong>: Delstrekningsnummer`
            );
        }

        if (vegsystemreferanse.strekning.meterAvgrensning) {
            const meter = vegsystemreferanse.strekning.meterAvgrensning;
            if (meter.slutt) {
                parts.push(
                    `<strong>M${meter.startEllerPunkt}-${meter.slutt}</strong>: Meteravgrensning`
                );
            } else {
                parts.push(`<strong>M${meter.startEllerPunkt}</strong>: Meterverdi`);
            }
        }
    }

    if (vegsystemreferanse.kryssystem) {
        const { trafikantgruppe } = vegsystemreferanse.kryssystem;

        if (trafikantgruppe) {
            const trafikantgruppeExplanation =
                getTrafikantgruppeExplanation(trafikantgruppe);
            parts.push(
                `<strong>${trafikantgruppe}</strong>: ${trafikantgruppeExplanation}`
            );
        }

        parts.push(
            `<strong>KD${vegsystemreferanse.kryssystem.kryssdel.startEllerPunkt}</strong>: Kryssdel`
        );
    }

    if (vegsystemreferanse.sideanlegg) {
        const { trafikantgruppe } = vegsystemreferanse.sideanlegg;

        if (trafikantgruppe) {
            const trafikantgruppeExplanation =
                getTrafikantgruppeExplanation(trafikantgruppe);
            parts.push(
                `<strong>${trafikantgruppe}</strong>: ${trafikantgruppeExplanation}`
            );
        }

        parts.push(
            `<strong>SD${vegsystemreferanse.sideanlegg.sideanleggsdel.startEllerPunkt}</strong>: Sideanleggsdel`
        );
    }

    return parts;
};

const getVegkategoriExplanation = (vegkategori: string): string => {
    switch (vegkategori.toUpperCase()) {
        case 'E':
            return 'Europaveg';
        case 'R':
            return 'Riksveg';
        case 'F':
            return 'Fylkesveg';
        case 'K':
            return 'Kommunal veg';
        case 'P':
            return 'Privat veg';
        case 'S':
            return 'Skogsveg';
        default:
            return '';
    }
};

const getFaseExplanation = (fase: string): string => {
    switch (fase.toUpperCase()) {
        case 'P':
            return 'Planlagt';
        case 'A':
            return 'Under bygging';
        case 'V':
            return 'Eksisterende';
        case 'F':
            return 'Fiktiv';
        default:
            return '';
    }
};

const getTrafikantgruppeExplanation = (trafikantgruppe: string): string => {
    switch (trafikantgruppe.toUpperCase()) {
        case 'K':
            return 'Kjørende';
        case 'G':
            return 'Gående og syklende';
        default:
            return '';
    }
};

export const createVegrefInfoBoxContent = (
    vegsystemreferanse: Vegsystemreferanse,
    vegrefFormatUrl: string
) => {
    return (
        <>
            <h3>Forklaring av vegsystemreferanse:</h3>
            <ul>
                {generateVegrefExplanation(vegsystemreferanse).map(
                    (explanation, index) => (
                        <li
                            key={index}
                            dangerouslySetInnerHTML={{ __html: explanation }}
                        />
                    )
                )}
            </ul>
            <p>
                <a rel="noopener noreferrer" target="_blank" href={vegrefFormatUrl}>
                    Les mer om vegsystemreferanser (nvdb-docs)
                </a>
            </p>
        </>
    );
};
